import { z } from "zod";

export const companiesForAutocompleteSchema = z.object({
    idUUID: z.string(),
    name: z.string().optional().nullable(),
    address: z.string().optional().nullable(),
    address2: z.string().optional().nullable(),
    city: z.string().optional().nullable(),
    state: z.string().optional().nullable(),
    zip: z.string().optional().nullable(),
    primaryPhoneNumber: z.string().optional().nullable(),
    faxNumber: z.string().optional().nullable(),
    emailAddress: z.string().optional().nullable(),
});
